import React, { useContext, useEffect } from 'react'
import AppContext from '../context/AppContext'

function useGetCountryInfo() {
  const { handlerCountryInfo } = useContext(AppContext)

  const defaultCountryInfo = {
    "country":"CL",
    "currencySymbol":"$",
    "codeIos":"CLP",
    "prefixNumber":"+56",
    "countryName":"Chile",
    "countryCode":"CL",
    "currency":"CLP"
  }

  useEffect(() => {
    if (!localStorage.getItem('countryName')) handlerCountryInfo({ city: '', countryCode: '', countryName: '' })

    let countryInfo = JSON.parse(localStorage.getItem('countryName')!)

    if(!countryInfo) {
      countryInfo = defaultCountryInfo
    }

    handlerCountryInfo({
      city: countryInfo?.city,
      countryCode: countryInfo?.countryCode,
      countryName: countryInfo?.countryName,
    })
  }, []) 

  return <div>useGetCountryName</div>
}

export default useGetCountryInfo
